import { useId } from "react";

import { cn } from "@/lib/utils";

export default function GridPattern({
  width = 48,
  height = 48,
  x = -1,
  y = -1,
  className,
  ...props
}) {
  const patternId = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("absolute inset-0 h-full w-full fill-none", className)}
      {...props}
    >
      <defs>
        <pattern
          id={patternId}
          width={width}
          height={height}
          x={x}
          y={y}
          patternUnits="userSpaceOnUse"
        >
          <path d={`M.5 ${height}V.5H${width}`} fill="none" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
}
